export const serverName = 'http://localhost:5050/';

export const domains = {
  url: '/api',
  auth: `https://${process.env.REACT_APP_DEBUG ? 'dev-' : ''}auth.ayomi.fr`,
};

export const BRAND = 'LEENDERS';